import React from 'react';

import { Separator } from '@radix-ui/themes';
import cn from 'classnames';

import styles from './FlyScreenCard.module.less';

type CommonProps = {
  header?: React.ReactNode;
  footer?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
};

type ScreenCardFormProps = CommonProps & {
  asForm: true;
  onSubmit: React.FormEventHandler<HTMLFormElement>;
};

type ScreenCardDivProps = CommonProps & {
  asForm?: false;
  onSubmit?: never;
};

type FlyScreenCardProps = ScreenCardFormProps | ScreenCardDivProps;

export const FlyScreenCard: React.FC<FlyScreenCardProps> = ({
  header,
  footer,
  children,
  asForm = false,
  className,
  onSubmit,
  ...props
}) => {
  const content = (
    <div
      className={styles.screenCardWrapper}
      data-testid='fly-screen-card'
      {...props}
    >
      {header && <header>{header}</header>}
      <div className={styles.content}>{children}</div>
      {footer && (
        <div className={styles.footerWrapper}>
          <Separator orientation='horizontal' size='4' />
          <footer className={styles.footer}>{footer}</footer>
        </div>
      )}
    </div>
  );

  return asForm ? (
    <form className={cn(styles.card, className)} onSubmit={onSubmit}>
      {content}
    </form>
  ) : (
    <div className={cn(styles.card, className)}>{content}</div>
  );
};
